// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DeviceInfo_wrap__3N7Pk","label":"DeviceInfo_label__15Wkx","device":"DeviceInfo_device__1Ymaq","name":"DeviceInfo_name__HzufQ","info":"DeviceInfo_info__1L7Fw"};